module.exports = __webpack_public_path__ + "img/ghana.269b4ae2.svg";